
    import { Component, Vue, Watch } from 'vue-facing-decorator';
    import { Getter, Mutation } from '@/plugins/vuex-decorators';
    @Component({
        components: {
        },
    })
    export default class Error extends Vue {

        private modalShow = false;

        @Mutation('SET_ERROR') setError: any;
        @Mutation('SET_STARTBUSY') setStartBusy: any;
        @Mutation('SET_STARTINPROGRESS') setStartInProgress: any;

        @Getter('getError') getError!: any;
        @Getter('getDebug') debug: any;

        @Watch('getError')
        private getErrorChanged() {
            if (this.getError != null) this.modalShow = true; else this.modalShow = false;
        }

        private get isUsageLimit(): boolean {
            return !!(this.getError && this.getError.response && this.getError.response.status === 402);
        }

        private get usageLimitMessage(): string {
            // Always show the friendly, category-free localized text in the UI. The exact
            // server message (which includes the category) is for API consumers / logs.
            return String(this.$t('message.usageLimitReachedBody'));
        }

        private close() {
            this.setError(null);
        }

        private reload() {
            this.setError(null);
            this.setStartBusy();
            this.setStartInProgress();
            window.location.reload();
        }

    }
